export let organismStates = {
    'Lined Seahorse': {
      growthRate: 0,  // cm/month
      health: 100,    // percent
      vitality: 10    // out of 10
    }
  };
  